<!-- Inline mode - no wrapper styling -->
<ng-container *ngIf="inlineMode">
  <div class="page-container inline-container">
    <!-- Back Button for inline mode -->
    <div class="inline-header">
      <button mat-button class="back-button-inline" (click)="goBack()">
        <mat-icon svgIcon="arrow-left"></mat-icon>
        Back
      </button>
    </div>
    
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading outputs...</p>
    </div>
    
    <!-- Outputs Table -->
    <div *ngIf="!loading" class="outputs-table-container table-container">
      <!-- Empty state when error occurred -->
      <div *ngIf="error" class="empty-state">
        <button mat-raised-button color="primary" (click)="goBack()">
          <mat-icon svgIcon="arrow-left"></mat-icon>
          Go Back
        </button>
      </div>
      
      <div *ngIf="outputs.length === 0 && !error" class="empty-state">
        <mat-icon svgIcon="folder_open"></mat-icon>
        <h2>No Outputs Yet</h2>
        <p>Outputs will appear here once your project runs are completed.</p>
      </div>

      <table *ngIf="outputs.length > 0 && !error" mat-table [dataSource]="outputs" class="outputs-table">
        <!-- File Name Column -->
        <ng-container matColumnDef="fileName">
          <th mat-header-cell *matHeaderCellDef>File Name</th>
          <td mat-cell *matCellDef="let output">
            {{ output.fileName }}
          </td>
        </ng-container>

        <!-- File Type Column -->
        <ng-container matColumnDef="fileType">
          <th mat-header-cell *matHeaderCellDef>File Type</th>
          <td mat-cell *matCellDef="let output">
            <div class="file-type-badge">
              <mat-icon *ngIf="isCustomIcon(getFileTypeIcon(output.fileName))" [svgIcon]="getFileTypeIcon(output.fileName)"></mat-icon>
              <mat-icon *ngIf="!isCustomIcon(getFileTypeIcon(output.fileName))">{{ getFileTypeIcon(output.fileName) }}</mat-icon>
              <span>{{ getFileType(output.fileName) }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Created On Column -->
        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef>Created On</th>
          <td mat-cell *matCellDef="let output">
            {{ output.createdAt | date:'yyyy-MM-dd HH:mm' }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let output" class="actions-cell">
            <button mat-icon-button class="action-btn download-btn" (click)="downloadOutput(output)" matTooltip="Download" aria-label="Download output">
              <mat-icon svgIcon="download-blue"></mat-icon>
            </button>
              <button mat-icon-button class="action-btn delete-btn" (click)="onDeleteOutput($event, output)" matTooltip="Delete" title="Delete output">
                <mat-icon svgIcon="delete"></mat-icon>
              </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</ng-container>

<!-- Standard mode - with wrapper styling -->
<div *ngIf="!inlineMode" class="content-wrapper-parent">
  <div class="content-wrapper">
    <div class="page-container">
      <div class="page-header">
    <div class="header-left">
      <button *ngIf="showBackButton" mat-icon-button class="back-button" (click)="goBack()">
        <mat-icon svgIcon="arrow-left"></mat-icon>
      </button>
      <h1>{{ projectName ? projectName + ' - Outputs' : 'Outputs' }}</h1>
    </div>
  </div>
  
  <!-- Outputs Table -->
  <div *ngIf="!loading" class="outputs-table-container table-container">
    <!-- Empty state when error occurred -->
    <div *ngIf="error" class="empty-state">
      <button mat-raised-button color="primary" (click)="goBack()">
        <mat-icon svgIcon="arrow-left"></mat-icon>
        Go Back
      </button>
    </div>
    
    <div *ngIf="outputs.length === 0 && !error" class="empty-state">
      <mat-icon svgIcon="folder_open"></mat-icon>
      <h2>No Outputs Yet</h2>
      <p>Outputs will appear here once your project runs are completed.</p>
    </div>

    <table *ngIf="outputs.length > 0 && !error" mat-table [dataSource]="outputs" class="outputs-table">
      <!-- File Name Column -->
      <ng-container matColumnDef="fileName">
        <th mat-header-cell *matHeaderCellDef>File Name</th>
        <td mat-cell *matCellDef="let output">
          {{ output.fileName }}
        </td>
      </ng-container>

      <!-- File Type Column -->
      <ng-container matColumnDef="fileType">
        <th mat-header-cell *matHeaderCellDef>File Type</th>
        <td mat-cell *matCellDef="let output">
          <div class="file-type-badge">
            <mat-icon *ngIf="isCustomIcon(getFileTypeIcon(output.fileName))" [svgIcon]="getFileTypeIcon(output.fileName)"></mat-icon>
            <mat-icon *ngIf="!isCustomIcon(getFileTypeIcon(output.fileName))">{{ getFileTypeIcon(output.fileName) }}</mat-icon>
            <span>{{ getFileType(output.fileName) }}</span>
          </div>
        </td>
      </ng-container>

      <!-- Created On Column -->
      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef>Created On</th>
        <td mat-cell *matCellDef="let output">
          {{ output.createdAt | date:'yyyy-MM-dd HH:mm' }}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let output" class="actions-cell">
          <button mat-icon-button class="action-btn download-btn" (click)="downloadOutput(output)" matTooltip="Download" aria-label="Download output">
            <mat-icon svgIcon="download-blue"></mat-icon>
          </button>
          <button mat-icon-button class="action-btn delete-btn" (click)="onDeleteOutput($event, output)" matTooltip="Delete" title="Delete output">
            <mat-icon svgIcon="delete"></mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  </div>
  </div>
</div>
